/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_Li6_LabelInputs */

const tr_mesafeli_s5_li6_label = /** @type {(inputs: Mesafeli_S5_Li6_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatalı Tahsilat İadesi:`)
};

const en_mesafeli_s5_li6_label = /** @type {(inputs: Mesafeli_S5_Li6_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund of Incorrect Charges:`)
};

const de_mesafeli_s5_li6_label = /** @type {(inputs: Mesafeli_S5_Li6_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstattung fehlerhafter Abbuchungen:`)
};

const ru_mesafeli_s5_li6_label = /** @type {(inputs: Mesafeli_S5_Li6_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возврат ошибочного списания:`)
};

/**
* | output |
* | --- |
* | "Refund of Incorrect Charges:" |
*
* @param {Mesafeli_S5_Li6_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_li6_label = /** @type {((inputs?: Mesafeli_S5_Li6_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_Li6_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_li6_label(inputs)
	if (locale === "de") return de_mesafeli_s5_li6_label(inputs)
	if (locale === "ru") return ru_mesafeli_s5_li6_label(inputs)
	return tr_mesafeli_s5_li6_label(inputs)
});